import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { Alert, Box, Button } from '@mui/material'

import FadeAnimationDiv from 'components/common/Animations'

import { TInfoTextWithButton } from '../../../types'
import { infoImg, warningImg } from '../../../utils'

import { useStyles } from './styles'

const AlertInfoTextWithButton: FC<TInfoTextWithButton> = ({ text, buttonText, pathname, icon = 'info', ...rest }) => {
    const styles = useStyles()
    const navigate = useNavigate()

    const handleClickButton = () => {
        navigate(pathname)
    }

    return (
        <FadeAnimationDiv>
            <Alert icon={false} className={styles.alert}>
                <Box className={styles.iconBox}>
                    <img className={styles.iconImg} src={icon === 'warning' ? warningImg : infoImg} alt="AlertIcon" />
                </Box>
                <Box className={styles.textWrapper}>
                    <span className="text">{text}</span>
                    <Button className={styles.button} onClick={handleClickButton} variant="outlined" {...rest}>
                        {buttonText}
                    </Button>
                </Box>
            </Alert>
        </FadeAnimationDiv>
    )
}

export default AlertInfoTextWithButton
